import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Divider, Form, Input } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

export default function CategoryForm({ form, onSubmit }) {
  const { t } = useTranslation()
  const { loading } = useSelector((state) => state?.categories)
  return (
    <Form
      layout="vertical"
      name="category_form"
      id="category_form"
      form={form}
      onFinish={onSubmit}
      disabled={loading}
      style={{
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      <Form.Item
        label={t("categories.crud.form.label.name")}
        name="titled"
        rules={[
          {
            required: true,
            message: t("categories.crud.form.error.label.required.name"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("categories.crud.form.label.description")}
        name="description"
        // rules={[
        //     {
        //         required: true,
        //         message: t(
        //             "categories.crud.form.error.label.required.description"
        //         ),
        //     },
        // ]}
      >
        <Input.TextArea />
      </Form.Item>
      <Form.List name="subCategories">
        {(fields, { add, remove }) => (
          <div>
            {fields?.map(({ key, name, ...restField }) => {
              return (
                <div>
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                        width: "100%",
                        margin: "0",
                      }}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, "titled"]}
                        validateTrigger={["onChange", "onBlur"]}
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message: t(
                              "categories.crud.form.error.label.required.subCategory.name",
                            ),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t(
                            "categories.crud.form.placeholder.subCategory.name",
                          )}
                        />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, "description"]}
                        validateTrigger={["onChange", "onBlur"]}
                        // rules={[
                        //     {
                        //         required: true,
                        //         whitespace: true,
                        //         message: t(
                        //             "categories.crud.form.error.label.required.subCategory.description"
                        //         ),
                        //     },
                        // ]}
                      >
                        <Input.TextArea
                          placeholder={t(
                            "categories.crud.form.placeholder.subCategory.description",
                          )}
                          rows={2}
                        />
                      </Form.Item>
                    </div>
                    {fields?.length > 0 ? (
                      <MinusCircleOutlined
                        className="dynamic-delete-button"
                        onClick={() => remove(name)}
                        style={{
                          alignSelf: "start",
                          marginTop: "10px",
                          color: "red",
                          fontSize: "20px",
                        }}
                      />
                    ) : null}
                  </div>
                  <Divider
                    style={{
                      margin: "10px 0",
                    }}
                  />
                </div>
              )
            })}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                style={{ width: "100%" }}
              >
                <PlusOutlined />{" "}
                {t("categories.crud.form.button.addSubCategory")}
              </Button>
            </Form.Item>
          </div>
        )}
      </Form.List>
    </Form>
  )
}
